import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import formAppSportRoomBlackouts from './formAppSportRoomBlackouts';
import viewRelatedSportRoomTeams from './viewRelatedSportRoomTeams';
import formSportRoomTeamsToCameraEdit from './formSportRoomTeamsToCameraEdit';
import formSportRoomTeamsToCameraMassUpdate from './formSportRoomTeamsToCameraMassUpdate';

export default {
  attributeName: 'teamsToCameraContentTable',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: false,
  isMultiSelectable:false,
  getURL:'sportRoomTeamToCameraContentPopup',
  updateURL:'sportRoomTeamToCameraContent',
  secondaryParamUrl:'massUpdate',
  // removeURL:'blackoutContent',
  idAttribute:'contentId',
  deleteRecordText:"You are about to delete a team from the camera. Do you still want to proceed?",
  // popupContentFormNew:[formAppSportRoomBlackouts],
  popupContentFormEdit:[formSportRoomTeamsToCameraEdit],
  popupContentFormSecondary:[formSportRoomTeamsToCameraMassUpdate],

  secondaryButtonText:'Mass update',

  emptyMessage: "No cameras in the live event has been found.",
  fields: [
    {
      attributeName: 'videoPublishID',
      label: 'Video publish ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Camera Name.',
      default: '',
      canEdit: false,
      canCreate: false,
    },
    {
      attributeName: 'teams',
      label: 'Teams',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedSportRoomTeams,
      helpText: 'Teams involved in this content, first will be the home team.',
      disabledWhenNew:true
    },
    {
      attributeName: 'visible',
      helpText: 'Sets when the VFX is going to be visible for this camera.',
      label: 'VFX visible',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'offset',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'VFX Offset',
      placeholder: 'milliseconds',
      helpText: 'Sets the VFX Offsets of the messages for this camera',
    },
    {
      attributeName: 'eventDetails',
      type: FormInputTypes.TEXT,
      label: 'VFX Config',
      helpText: 'VFX config details',
    },
  ],
};
